/* eslint-disable react/no-unused-prop-types */

// NPM Imports
import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// CSS imports
import styles from "./revvToastr.module.scss";

// Internal Imports
import { createBaseContainer, hideToastr, showToastr } from "./methods";

// Component Imports
import Button from "../Button";

// Local Declarations
let hideToastrFn;

class Toastr extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toastrList: [],
      limitTo: 1,
    };

    Toastr.showToastr = showToastr.bind(this);
    hideToastrFn = hideToastr.bind(this);
  }

  _decideStatusIco = status => {
    switch (status) {
      case "success":
        return "check-circle";
      case "warning":
        return "exclamation-triangle";
      case "failure":
        return "times-octagon";
      default:
        return "check-circle";
    }
  };

  render() {
    const { toastrList, limitTo } = this.state;

    return ReactDOM.createPortal(
      <div className={styles.wrapper}>
        {toastrList && toastrList.length > 0 && (
          <ul className={styles.toastrListContainer}>
            {[...toastrList].reverse().map((item, index) => {
              if (index < limitTo) {
                return (
                  <li className={styles.listItem} key={item.id}>
                    <div className={styles.container}>
                      <div
                        data-test={`revv-toastr-${item.type}`}
                        className={`${styles.statusIco} ${
                          styles[item.type || "success"]
                        }`}>
                        <FontAwesomeIcon
                          icon={["fas", this._decideStatusIco(item.type)]}
                        />
                      </div>
                      <div data-test="revv-toastr-msg" className={styles.msg}>
                        {item.message}
                      </div>
                      <Button
                        data-test="revv-toastr-msg-close"
                        className={styles.close}
                        onClick={() => hideToastrFn(item)}>
                        ×
                      </Button>
                    </div>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        )}
      </div>,
      document.querySelectorAll(".revv-toastr-holder")[0],
    );
  }
}

createBaseContainer();
if (typeof window !== "undefined") {
  ReactDOM.render(
    <Toastr />,
    document.querySelectorAll(".revv-toastr-holder")[0],
  );
}
Toastr.defaultProps = {
  type: "success",
  timeout: 3000,
};

Toastr.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string.isRequired,
  timeout: PropTypes.number,
};

export default Toastr;
